// WO-MEMBER-STATE-PROPAGATION-001 · P0 sweep — the two booking-chrome colour tokens, out from behind
// the client boundary. `BookingChrome.tsx` is `"use client"` and `BookingIcons.tsx` imported these
// from it. Same class as the `splitPricePair` 500.
export const ORANGE = "var(--sg-color-avalanche-orange)"; // #FC500E — the export's brand signal
export const GREY = "var(--sg-grey-500)"; //  #7E8A92 — the export's secondary text
